import axios from '../localAxios';
import { questionScoresURL } from './questionScoresURL';

export type CreateQuestionScoresBody = {
  grading_weight: number;
  ungraded_score: number;
};

export type CreateQuestionScoresResponse = {
  id: number;
  questionId: number;
  activityInstanceId: number;
  gradingWeight: number;
  ungradedScore: number;
  updatedDate: string;
};

export async function createQuestionScores({
  activityInstanceId,
  gradingWeight,
  ungradedScore = 0,
  questionId,
}: {
  activityInstanceId: number;
  gradingWeight: number;
  ungradedScore?: number;
  questionId: number;
}) {
  const url = questionScoresURL({ activityInstanceId, questionId });
  const request: CreateQuestionScoresBody = {
    grading_weight: gradingWeight,
    ungraded_score: ungradedScore,
  };
  const { data } = await axios.post<CreateQuestionScoresResponse>(
    url.href,
    request
  );
  return data;
}
